const Cross2 = ({ ...props }) => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9.5" cy="9.5" r="9.25" fill="#DEDEDE" stroke="#E0E0E0" stroke-width="0.5" />
      <path d="M4.75 14.6019L14.25 4.75" stroke="#424242" />
      <path d="M14.25 14.6019L4.75 4.75" stroke="#424242" />
    </svg>
  )
}

export default Cross2
